import { render } from "./BusinessInfoDialog.vue?vue&type=template&id=6b97a178"
import script from "./BusinessInfoDialog.vue?vue&type=script&lang=js"
export * from "./BusinessInfoDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__